enum ActionTypes {
  LOAD_APP_SCAFFOLD_REQUEST = 'LOAD_APP_SCAFFOLD_REQUEST',
  LOAD_APP_SCAFFOLD_SUCCESS = 'LOAD_APP_SCAFFOLD_SUCCESS',
  LOAD_APP_SCAFFOLD_FAILURE = 'LOAD_APP_SCAFFOLD_FAILURE'
}

export default ActionTypes;
